module.exports = __webpack_public_path__ + "img/google-icon.81ad048e.svg";